
import { Component, Vue } from 'vue-property-decorator'
import { IExpData } from '@/types/reporter-types'
import { ReporterService } from '@/services/index'
import AddExp from './addExp.vue'
import { parseTime } from '@/common/utils'

@Component({
    name: 'Career',
    components: {
        AddExp
    }
})
export default class extends Vue {
    private reporterId: number = 0
    private exps: any = []

    private mounted() {
        this.reporterId = parseInt(this.$route.params.id)
        this.getExps()
    }

    private async getExps() {
        const result = await ReporterService.getExps({ id: this.reporterId })
        if (result.status === 200) {
            this.exps = result.data
        }
    }

    private async addExp(exp: any) {
        const result = await ReporterService.addExp(exp)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '新增成功' })
            // this.exps.unshift(Object.assign(exp, { id: result.data.id }))
        } else {
            this.$message.error(result.message)
        }
    }

    private async updateExp(exp: any) {
        const result = await ReporterService.updateExp(exp)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '修改成功' })
            this.exps.map((item: IExpData, index: number) => {
                if (item.id === exp.id) {
                    this.exps.splice(index, 1, exp)
                }
            })
        } else {
            this.$message.error(result.message)
        }
    }

    private async removeExp(expId: number) {
        const result = await ReporterService.deleteExp({ id: expId })
        if (result.status === 200) {
            this.$message({ type: 'success', message: '删除成功' })
            this.exps.map((exp: IExpData, index: number) => {
                if (exp.id === expId) {
                    this.exps.splice(index, 1)
                }
            })
        } else {
            this.$message.error(result.message)
        }
    }

    private filterEndDate(endDate: string) {
        if (endDate === '') return '至今'
        return parseTime(endDate, '{y}-{m}')
    }

    private onAddExp() {
        (this.$refs.addExp as any).show(null, (exp: IExpData) => {
            exp = Object.assign(exp, { rid: this.reporterId })
            this.addExp(exp).then(() => {
                this.getExps()
            })
        })
    }

    private onRemoveExp(expId: number) {
        this.$confirm('确定删除该工作经历?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.removeExp(expId)
        }).catch(() => {})
    }

    private onEditExp(expId: number, expIndex: number) {
        (this.$refs.addExp as any).show(this.exps[expIndex], (exp: IExpData) => {
            this.updateExp(exp)
        })
    }
}
